var consumer = {
  "units": {
    "Wh": {
      "single": "wattora",
      "plural": "wattora",
      "annotated_abv": "(Wh)",
      "abv": "Wh",
      "definition": "La produzione e il consumo di energia sono misurati in wattora (Wh). Un kilowattora (kWh) equivale a 1.000 wattora ed è l'unità di misura usata comunemente nelle bollette mensili per le utenze elettriche."
    },
    "kWh": {
      "single": "kilowattora",
      "plural": "kilowattora",
      "annotated_abv": "(kWh)",
      "abv": "kWh"
    },
    "MWh": {
      "single": "megawattora",
      "plural": "megawattora",
      "annotated_abv": "(MWh)",
      "abv": "MWh"
    },
    "GWh": {
      "single": "gigawattora",
      "plural": "gigawattora",
      "annotated_abv": "(GWh)",
      "abv": "GWh"
    },
    "TWh": {
      "single": "terawattora",
      "plural": "terawattora",
      "annotated_abv": "(TWh)",
      "abv": "TWh"
    },
    "PWh": {
      "single": "petawattora",
      "plural": "petawattora",
      "annotated_abv": "(PWh)",
      "abv": "PWh"
    },
    "EWh": {
      "single": "exawattora",
      "plural": "exawattora",
      "annotated_abv": "(EWh)",
      "abv": "EWh"
    },
    "ZWh": {
      "single": "zetawattora",
      "plural": "zetawattora",
      "annotated_abv": "(ZWh)",
      "abv": "ZWh"
    },
    "YWh": {
      "single": "yottawattora",
      "plural": "yottawattora",
      "annotated_abv": "(YWh)",
      "abv": "YWh"
    },
    "W": {
      "single": "watt",
      "plural": "watt",
      "annotated_abv": "(W)",
      "abv": "W"
    },
    "kW": {
      "single": "kilowatt",
      "plural": "kilowatt",
      "annotated_abv": "(kW)",
      "abv": "kW"
    },
    "MW": {
      "single": "megawatt",
      "plural": "megawatt",
      "annotated_abv": "(MW)",
      "abv": "MW"
    },
    "GW": {
      "single": "gigawatt",
      "plural": "gigawatt",
      "annotated_abv": "(GW)",
      "abv": "GW"
    },
    "TW": {
      "single": "terawatt",
      "plural": "terawatt",
      "annotated_abv": "(TW)",
      "abv": "TW"
    },
    "PW": {
      "single": "petawatt",
      "plural": "petawatt",
      "annotated_abv": "(PW)",
      "abv": "PW"
    },
    "EW": {
      "single": "exawatt",
      "plural": "exawatt",
      "annotated_abv": "(EW)",
      "abv": "EW"
    },
    "ZW": {
      "single": "zettawatt",
      "plural": "zettawatt",
      "annotated_abv": "(ZW)",
      "abv": "ZW"
    },
    "YW": {
      "single": "yottawatt",
      "plural": "yottawatt",
      "annotated_abv": "(YW)",
      "abv": "YW"
    },
    "percent": {
      "single": "percentuale",
      "plural": "percentuale",
      "annotated_abv": "%",
      "abv": "%"
    },
    "minutes": {
      "zero": "minuti",
      "ltone": "minuto",
      "single": "minuto",
      "plural": "minuti"
    },
    "hours": {
      "zero": "ore",
      "ltone": "ora",
      "single": "ora",
      "plural": "ore"
    },
    "months": {
      "zero": "mesi",
      "ltone": "mese",
      "single": "mese",
      "plural": "mesi"
    },
    "years": {
      "zero": "anni",
      "ltone": "anno",
      "single": "anno",
      "plural": "anni"
    },
    "days": {
      "zero": "giorni",
      "ltone": "giorno",
      "single": "giorno",
      "plural": "giorni"
    },
    "nights": {
      "zero": "notti",
      "ltone": "notte",
      "single": "notte",
      "plural": "notti"
    },
    "batteries": {
      "zero": "batterie",
      "ltone": "batteria",
      "single": "batteria",
      "plural": "batterie"
    },
    "trees": {
      "zero": "alberi",
      "ltone": "albero",
      "single": "albero",
      "plural": "alberi"
    },
    "kg": {
      "zero": "kg",
      "ltone": "kg",
      "single": "kg",
      "plural": "kgs"
    },
    "laps": {
      "zero": "giri",
      "ltone": "giro",
      "single": "giro",
      "plural": "giri"
    },
    "barrels": {
      "zero": "barili",
      "ltone": "barile",
      "single": "barile",
      "plural": "barili"
    },
    "flights": {
      "zero": "voli",
      "ltone": "volo",
      "single": "volo",
      "plural": "voli"
    },
    "launches": {
      "zero": "lanci",
      "ltone": "lancio",
      "single": "lancio",
      "plural": "lanci"
    }
  },
  "timeAgo": {
    "now": "Adesso",
    "second": {
      "single": "1 secondo fa",
      "plural": "%{number} secondi fa"
    },
    "minute": {
      "single": "1 minuto fa",
      "plural": "%{number} minuti fa"
    },
    "hour": {
      "single": "1 ora fa",
      "plural": "%{number} ore fa"
    },
    "day": {
      "single": "1 giorno fa",
      "plural": "%{number} giorni fa"
    },
    "week": {
      "single": "1 settimana fa",
      "plural": "%{number} settimane fa"
    },
    "month": {
      "single": "1 mese fa",
      "plural": "%{number} mesi fa"
    },
    "year": {
      "single": "1 anno fa",
      "plural": "%{number} anni fa"
    }
  },
  "weather": {
    "unknown": "Meteo sconosciuto",
    "footer": "Dati meteo forniti da The Weather Company.",
    "credit": "Fonte: The Weather Company"
  },
  "reports": {
    "title": "Report",
    "submit": "Avvia report",
    "to": "a",
    "selectDate": "Select the date",
    "insufficientData": "Controlla domani. Il cloud Enphase non ha raccolto i dati richiesti per creare i rapporti.",
    "1": {
      "name": "Produzione giornaliera",
      "title": "Produzione di energia del sito",
      "description": "Riepilogo della produzione di energia giornaliera per questo sito. Poiché questo report fornisce l'energia su base giornaliera, è possibile richiedere date fino a ieri."
    },
    "2": {
      "name": "Produzione recente",
      "title": "Produzione di energia recente del sito",
      "description": "Riepilogo della produzione di energia dell'ultima settimana in incrementi da 5 minuti per questo sito."
    },
    "6": {
      "name": "Produzione mensile",
      "title": "Produzione energetica mensile",
      "description": "Riepilogo della produzione di energia mensile e potenza di picco per questo sito."
    },
    "15": {
      "name": "Consumo giornaliero",
      "title": "Consumo di energia del sito",
      "description": "Riepilogo del consumo di energia giornaliero per questo sito. Poiché questo report fornisce l'energia su base giornaliera, è possibile richiedere date fino a ieri."
    },
    "16": {
      "name": "Consumo recente",
      "title": "Consumo di energia recente del sito",
      "description": "Riepilogo del consumo di energia dell'ultima settimana in incrementi da 15 minuti per questo sito."
    },
    "17": {
      "name": "Energia netta mensile",
      "title": "Energia netta mensile",
      "description": "Questo report fornisce un riepilogo dell'energia prodotta, consumata, importata ed esportata da questo sito a intervalli regolari di 15 minuti per il mese selezionato. Se il sistema dispone di batterie CA, il report indica anche l'energia accumulata e scaricata."
    },
    "19": {
      "name": "Report batteria",
      "title": "Report batteria",
      "description": "Il report fonrisce i dati relativi agli ultimi 7 giorni della batteria"
    },
    "3": {
      "name": "Produzione energetica giornaliera per modulo",
      "title": "Produzione energetica giornaliera per modulo",
      "description": "Questo report fornisce la produzione di energia di tutti i microinverter alla data specificata."
    },
    "5": {
      "name": "Produzione energetica mensile per modulo",
      "title": "Produzione energetica mensile per modulo",
      "description": "Questo report fornisce la produzione di energia di tutti i microinverter per il mese specificato."
    },
    "20": {
      "name": "Rapporto test automatico di IQ-Relay",
      "title": "Rapporto risultati test automatico di IQ-Relay",
      "description": "Questo rapporto fornisce i risultati dell'ultimo test automatico effettuato da IQ-Relay"
    },
    "25": {
      "name": "Rapporto personalizzato (in Wh)",
      "title": "Rapporto personalizzato",
      "description": ""
    }
  },
  "stats": {
    "total": "Energia totale",
    "peak_production": "Potenza di picco",
    "latest_production": "Ultima potenza",
    "peak_consumption": "Picco di consumo",
    "latest_consumption": "Consumo più recente",
    "recent_power": "Potenza recente",
    "maintainer": "Contattare il proprio addetto alla manutenzione",
    "enphase": "Contatta l'assistenza Enphase",
    "orenphase": "In alternativa, contattare l'assistenza Enphase",
    "learn_more": "Ulteriori informazioni.",
    "where": "Qual è il problema?",
    "toGrid": "Circa %{value} esportati alla rete",
    "fromGrid": "Circa %{value} importati dalla rete",
    "normal": {
      "title": "Normale",
      "modal": "Il sistema sta funzionando normalmente."
    },
    "shortcomm": {
      "title": "Gateway non segnalato",
      "hours": "Il tuo sistema non ha riportato dati al cloud Enphase nelle ultime %{hours} ore.",
      "date": "Il tuo sistema non riporta dati al cloud Enphase dal %{date}.",
      "unknown": "Questo sistema non riporta dati al cloud Enphase.",
      "question": "La connessione Internet è inattiva?",
      "help_topic_link": "Riconnettersi per controllare le prestazioni del sistema.",
      "link": "Fare clic qui per richiedere assistenza."
    },
    "meter": {
      "title": "Il contatore non invia report",
      "hours": "Il contatore del sistema non ha segnalato al gateway nelle ultime %{hours} ore.",
      "date": "Il contatore del sistema non ha segnalato al gateway dal %{date}.",
      "ct_wiring": "Si è verificato un problema con le misurazioni del contatore gateway. Contattare il proprio addetto alla manutenzione per assistenza.",
      "unknown": "Il contatore del sistema non segnala il gateway.",
      "link": "Fare clic qui per richiedere assistenza.",
      "modal": "Da allora il contatore non ha segnalato dati al gateway"
    },
    "meter_issue": {
      "title": "Errore contatore",
      "ct_wiring": "È presente un errore nelle misure del contatore di Envoy",
      "link": "Fare clic qui per richiedere assistenza."
    },
    "battery": {
      "title": "Le batterie CA non inviano report",
      "modal": "La batteria CA non sta inviando dati.",
      "message": "Alcune batterie CA non stanno inviando dati.",
      "messageSome": "Alcune batterie CA (%{count}) non stanno inviando dati.",
      "link": "Fare clic qui per l'assistenza."
    },
    "storage_idle": {
      "title": "Stoccaggio non attivo",
      "modal": "La batteria CA non si sta caricando o scaricando.",
      "date": "Almeno una batteria CA non si è caricata o scaricata dal %{date}.",
      "unknown": "Almeno una batteria CA non si sta caricando o scaricando.",
      "link": "Fare clic qui per l'assistenza."
    },
    "encharge": {
      "title": "La batteria non trasmette",
      "modal": "Questa batteria non sta inviando dati.",
      "message": "La batteria non sta inviando dati. Ciò può verificarsi se la comunicazione wireless tra il gateway e la batteria è debole. Questo potrebbe essere un problema tecnico temporaneo e dovrebbe risolversi al più presto.",
      "requestMaintainer": "Se il problema persiste, contatta il tuo manutentore per assistenza.",
      "messageSome": "Alcune batterie (%{count}) non trasmettono i dati.",
      "link": "Clicca qui per aiuto."
    },
    "enpower": {
      "title": "Il controller di sistema non trasmette",
      "modal": "Questo controller di sistema non sta trasmettendo dati.",
      "message": "Il controller di sistema non sta trasmettendo i dati. Ciò può verificarsi se la comunicazione wireless tra il gateway e il controller di sistema è debole. Questo potrebbe essere un problema tecnico temporaneo e dovrebbe risolversi al più presto.",
      "requestMaintainer": "Se il problema persiste, contatta il tuo manutentore per assistenza.",
      "messageSome": "Alcuni controller di sistema (%{count}) non trasmettono i dati.",
      "link": "Clicca qui per aiuto."
    },
    "encharge_issue": {
      "title": "Errore batteria",
      "modal": "Questa batteria ha un errore.",
      "message": "La batteria ha un errore."
    },
    "enpower_issue": {
      "title": "Errore controller di sistema",
      "modal": "Questo controller di sistema ha un errore.",
      "message": "Il controller di sistema ha un errore."
    },
    "micro": {
      "title": "I microinverter non inviano report",
      "modal": "Questo microinverter non trasmette i dati al gateway.",
      "message": "Alcuni microinverter non segnalano i dati al gateway.",
      "messageSome": "Alcuni microinverter (%{count}) non segnalano i dati al gateway.",
      "messageAll": "Nessun microinverter trasmette dati al gateway.",
      "link": "Fare clic qui per l'assistenza."
    },
    "power": {
      "title": "Errore di produzione del sistema",
      "message": "Si è verificato un problema di produzione nel sistema in uso.",
      "messageSome": "Il microinverter sta segnalando un problema di produzione.",
      "messageThreshold": "Il sistema sta producendo meno energia rispetto a quella prevista.",
      "link": "Contattare l'assistenza Enphase.",
      "maintainerlink": "Contattare il proprio addetto alla manutenzione per assistenza."
    }
  }
};
module.exports = consumer;